import { render, staticRenderFns } from "./Page2.vue?vue&type=template&id=fcde20ca"
import script from "./Page2.vue?vue&type=script&lang=js"
export * from "./Page2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports